// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ScheduledMaintenanceResultDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class ScheduledMaintenanceResultApiClient extends BaseCRUDApiClient<ScheduledMaintenanceResultDto> {
  baseUrl = this.config.apiEndpoint + '/scheduled-maintenance-result';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
